import AssigneesBar from './assignees_bar';

export default AssigneesBar;
